import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Input, Injector} from '@angular/core';
import {fadeInAnimation, fadeInOut} from '../../../common/service/routerTransition';
import {TranslateService} from '@ngx-translate/core';
import { ModalBase } from '../../../common/components/modal.base.component';
import { DialogService } from '../../../common/service/dialog.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventManagerService } from 'src/app/common/service/event-manager.service';
import { AppQueries } from 'src/app/state';
import { CustomComponentService } from 'src/app/main/services/custom-component.service';
@Component({
    selector: 'detail-issuer',
    templateUrl: './detail-issuer.html',
    animations: [fadeInAnimation, fadeInOut],
    host: {'[@fadeInAnimation]': ''}
  })
  
export class DetailIssuer extends ModalBase implements OnInit, AfterViewInit {
    @Input('issuer') issuer;
    constructor(
        public activeModal: NgbActiveModal,
        public customComponentService: CustomComponentService,
        public sanitizer:DomSanitizer,
        dialog: DialogService,
        injector: Injector) {
            super(injector)
    }
    ngOnInit() {
        !this.issuer && ( this.issuer = {})
    }
    ngAfterViewInit() {
    }
    cancel(modal) {
        this.issuer = {};
        super.cancel(modal);
    }
    sanitize(url:string){
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
}